module.exports = fox._r("images/welcome-img.jpg", __webpack_public_path__ + "images/welcome-img.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/welcome-img.jpg
// module id = 1138
// module chunks = 4